module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/pin02-ed4c07c37c9b6b13aa36cc5851ec5a23.svg";